module.exports = __webpack_public_path__ + "img/چهار-لت.18083d37.png";